import React, { useRef, useEffect, useCallback, useState} from 'react';
import {mod} from "utils/mod.js";
import {connect} from 'react-redux';
import Resolution from 'engine/Resolution.js';

const BASE_RESOLUTION = new Resolution(32, false);

const Bars = ({
    stepsRef,
    numberOfSteps,
    setSelectedBar,
    selectedBar,
    resolution,
    isFollowing,
    setIsFollowing,
    patternStep,
    barLength,
    cirklonRef,
}) => { 


    let [currentBar, setCurrentBar] = useState(0);
   
    let numBars = Math.floor(numberOfSteps / barLength);
    if (isNaN(numBars)) {
        numBars = 1;
    }

    let lastWheel = useRef(undefined);
    let lastDeltaX = useRef(undefined);

    useEffect(() => {
        stepsRef.current.addEventListener("mousewheel", onWheel, {passive: false});
        return () => {
            if (stepsRef.current) {
                stepsRef.current.removeEventListener("mousewheel", onWheel, {passive: false});
            }
        };
    }, [selectedBar, setSelectedBar, setIsFollowing, numBars]);

    const onWheel = useCallback((e) => {
        let now = new Date().getTime();
        if (now - window.lastScrollTime < 200) {
            return;
        }

        e.stopPropagation();
        e.preventDefault();

        let isLowering = Math.abs(e.deltaX) <= Math.abs(lastDeltaX.current);
        lastDeltaX.current = e.deltaX;
        if (e.deltaX > 0) {
            if (now - lastWheel.current < 200) {
                if (!isLowering) {
                    lastWheel.current = now;
                }
                return true;
            }
            if (isLowering) {
                return true;
            }
            setIsFollowing(false);
            let _selectedBar = (selectedBar + 1) % numBars;
            if (!isNaN(selectedBar)) {
                setSelectedBar(_selectedBar);
            }
            lastWheel.current = now;
        } else if (e.deltaX < 0) {
            if (now - lastWheel.current < 200) {
                if (!isLowering) {
                    lastWheel.current = now;
                }
                return true;
            }
            if (isLowering) {
                return true;
            }
            setIsFollowing(false);
            let _selectedBar = mod(selectedBar - 1, numBars);
            if (!isNaN(_selectedBar)) {
                setSelectedBar(_selectedBar);
            }
            lastWheel.current = now;
        }
        return true;
    }, [selectedBar, setIsFollowing, setSelectedBar, numBars]);

    useEffect(() => {
        if (isNaN(selectedBar) || selectedBar >= numBars) {
            setSelectedBar(0);
        }
    }, [numBars, selectedBar, setSelectedBar]);

    let arr = Array(numBars).fill(1);
    let start = barLength * selectedBar;
    let end = barLength * (selectedBar + 1);

    useEffect(() => {
        setCurrentBar(Math.floor(patternStep / barLength));
        if (patternStep >= start && patternStep < end) {
        } else if (!isNaN(patternStep) && isFollowing) {
            let _barLength = Math.floor(patternStep / barLength);
            setSelectedBar(_barLength);
        }
    }, [patternStep, start, end, setSelectedBar, barLength, isFollowing, setCurrentBar]);


    if (numBars === 1) {
        return [];
    }
    return (
        <div className="bars">
          <div className="bar-label">
            Bar: 
          </div>
          {arr.map(
              (x, i) =>
                  <Bar
                    bar={i}
                    isCurrent={currentBar === i}
                    isSelected={selectedBar === i}
                    onClick={() => {
                        setSelectedBar(i);
                        setIsFollowing(false);
                    }}
                  />)}
          <div
            onClick={() => setIsFollowing(!isFollowing)}
            className={isFollowing ? "following follow-btn" : "follow-btn"}>
            FOLLOW
          </div>
        </div>
    );
};

const Bar = ({bar, isSelected, onClick, isCurrent}) => {
    let className = "bar";
    if (isSelected) {
        className += " selected";
    }
    if (isCurrent) {
        className += " current";
    }
    return (
        <div
          onClick={onClick}
          className={className}>
          <div className="bar-text">{bar+1}</div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
    let resolution = state.sequencer.displayResolution;
    let trackStep = props.track.sequencerEngine.trackStep;
    let patternStep = Math.floor(resolution.transformStepAtResolution2(
        props.track.getPatternStep(trackStep),
        BASE_RESOLUTION));

  return {
      patternStep: patternStep,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Bars);
